import { useLazyGetUsersQuery } from '../../../../api/userApi';
import { CircularProgress } from '@mui/joy';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { UserActions } from '../../PanelActions/enums';
import { FilterContainer } from '../../../../components/ui/FIlterContainer';
import { UserFilters } from '../../../../types/filter';
import { FilterUsersList } from './UserFilters';
import { useAdminPanelUI } from '../../../../hooks/useAdminPanelUI';
import AddRoundedIcon from '@mui/icons-material/AddRounded';

interface Props {
    setUserSelected: Dispatch<SetStateAction<number>>;
}

export function UsuariosList({ setUserSelected }: Props) {
    const { setUserAction } = useAdminPanelUI();

    const [trigger, { data: users, isLoading, isSuccess, isFetching }, lastPromiseInfo] = useLazyGetUsersQuery();
    const [filters, setFilters] = useState<UserFilters>({
        nombre: "",
        rol: "",
        status: "",
    });

    const getUsers = (filtros: UserFilters) => {
        try {
            trigger(filtros);
        } catch (error) {
            
        }
    }

    useEffect(() => {
        getUsers(filters);
    }, []);

    return (
        <div className="h-full w-full flex flex-col">

            <div className="my-4 mx-2">
                <button 
                    onClick={() => setUserAction(UserActions.UserCreateForm)}
                    className="bg-green-800 h-[30px] w-[90px] rounded px-[6px] py-[4px] flex gap-1 items-center mb-2">
                    <AddRoundedIcon sx={{ height: 15, width: 15, color: "white" }}/>
                    <p className="text-white text-[13px] font-semibold">Usuario</p>
                </button>
            </div>


            <div className="flex items-center px-3 py-1 w-full">
                <FilterContainer width="w-[800px]">
                    <FilterUsersList 
                        triggerFetch={getUsers}
                        filters={filters}
                        setFilters={setFilters}/>
                </FilterContainer>
            </div>

            <p className="font-semibold text-xl mb-2 mx-2">Lista de usuarios</p>
            {isLoading || isFetching
            ? 
            <div className="flex justify-center items-center h-full w-full">
                <CircularProgress />
            </div>
            :
            <div className="border-0 border-gray-400 overflow-auto flex-1">
                <table className="w-full">
                    <thead>
                        <tr>
                            <th className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                                Nombre
                            </th>
                            <th className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                                Rol
                            </th>
                            <th className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                                Correo
                            </th>
                            <th className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                                Estado
                            </th>
                            <th className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                                Detalles
                            </th>
                        </tr>
                    </thead>
                    <tbody className="text-[14px]">
                        {isSuccess && users.map((user, index) => (
                        <tr key={index}
                            className="hover:bg-gray-100">
                            <td className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-[14px] font-semibold text-[#111827]">
                                {user.nombre}
                            </td>
                            <td className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                                {user.rol}
                            </td>
                            <td className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-[14px] font-semibold text-[#111827]">
                                {user.correo}
                            </td>
                            <td className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                                {user.estatus}
                            </td>
                            <td className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                                <p
                                className="cursor-pointer hover:text-blue-900 hover:underline"
                                onClick={() => {
                                    setUserSelected(user.id);
                                    setUserAction(UserActions.UserDetails);
                                }}>
                                    Detalles
                                </p>
                            </td>
                        </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            }

        </div>
    );
}
